PF.ListCrudPage.Item.Edit = class ItemEdit extends PF.Trait
	{
	initTrait()
		{
		super.initTrait();

		this.on('startEdit', (event) => {
			app.pageParams.setData(this.list.models.idIndex, this.model[this.list.models.idIndex]);

			app.router.navigate(this.list.editPage);
		});

		}
	};